import { SongStorageState } from './types';

export const songStorageInitialState: SongStorageState = {
  storeSongMetadata: [],
};
